
import React from 'react';
import CareerObjectives from '../CareerObjectives';
import SimulationStatus from '../SimulationStatus';

const ObjectivesTab: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <CareerObjectives />
      <SimulationStatus />
    </div>
  );
};

export default ObjectivesTab;
